import { render } from "./IndicatorSettings.vue?vue&type=template&id=49d7504a&scoped=true"
import script from "./IndicatorSettings.vue?vue&type=script&lang=js"
export * from "./IndicatorSettings.vue?vue&type=script&lang=js"

import "./IndicatorSettings.vue?vue&type=style&index=0&id=49d7504a&scoped=true&lang=css"
import "./IndicatorSettings.vue?vue&type=style&index=1&id=49d7504a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d7504a"]])

export default __exports__